import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SentrySplashScreen from '../sentry-pwa/SentrySplashScreen';
import SentryWalletConnectionScreen from '../sentry-pwa/SentryWalletConnectionScreen';

type FlowStage = 'splash' | 'wallet-connection';

const SentryDesktopEntryFlow: React.FC = () => {
  const navigate = useNavigate();
  const [stage, setStage] = useState<FlowStage>('splash');

  useEffect(() => {
    if (stage === 'splash') {
      const timer = setTimeout(() => {
        setStage('wallet-connection');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [stage]);

  if (stage === 'splash') {
    return <SentrySplashScreen fullWidth />;
  }

  return (
    <SentryWalletConnectionScreen
      onProceed={() => navigate('/sentry-desktop/dashboard')}
      onAgentProceed={() => navigate('/sentry-agent/wallet')}
      allowTelegram={false}
      fullWidth
      accountButtonLabel="Login"
    />
  );
};

export default SentryDesktopEntryFlow;
